export default {
  filter: '',
  organizations: []
}
